import type { PageLayout } from "@/components/page-chrome/page-layout"

// The pages outside every workspace, keyed by Inertia component name, with
// the facts the shell reads before a page's code runs. None walks a trail:
// the sign-in and password pages draw a card alone, the account page draws
// its own chrome, and Error is a root page under the header, in the bare
// layout. Error has no domain of its own, so it is registered here with the
// other pages that belong to no workspace.
export const userPages = {
  "users/sessions/new": { layout: "bare" },
  "users/passwords/new": { layout: "bare" },
  "users/passwords/edit": { layout: "bare" },
  "users/registrations/edit": { layout: "standard" },
  Error: { layout: "bare" },
} as const satisfies Record<string, { layout: PageLayout }>
